import { defineComponent as _defineComponent } from 'vue'
import { ref as _ref, computed as _computed } from 'vue';

import { getCurrentInstance, onMounted } from 'vue';
import ModalDialog from '@/components/modal-dialog/Modal-Dialog.vue';
import { validateCron } from '@/utils/cron-validators';
import { usePlans, PlanTypes } from '@/composables/plans';
import i18n from '@/i18n';



interface InputCronProps {
  isDatasource?: boolean;
  hint?: string;
  minDefaultPeriod?: number;
}


const DEFAULT_MIN_DATASOURCE_PERIOD_SECONDS = 86400

export default /*#__PURE__*/_defineComponent({
  __name: 'Input-Cron',
  props: {
  isDatasource: { type: Boolean },
  hint: null,
  minDefaultPeriod: null
},
  emits: ['input'],
  setup(__props, { emit }) {

const props = __props;



const vm = getCurrentInstance();
const plans = usePlans();

let isPlanLoaded = _ref(false);
const modalDialog = _ref<InstanceType<typeof ModalDialog> | null>(null);
const inputCron = _ref<any>(null);

const cronItems = [
  { text: '@minutely', duration: 60 },
  { text: '@hourly', duration: 3600 },
  { text: '@daily', duration: 86400 },
  { text: '@weekly', duration: 604800 },
  { text: '@monthly', duration: 2419200 },
];

const headers = [
  { text: 'Entry', value: 'entry' },
  { text: 'Description', value: 'desc' },
  { text: 'Equivalent to', value: 'eqt' },
];

const items = [
  { entry: '@yearly (or @annually)', desc: i18n.t('cron.run_once_a_year'), eqt: '0 0 1 1 *' },
  { entry: ' @monthly', desc: i18n.t('cron.run_once_a_month'), eqt: '0 0 1 * *' },
  { entry: '@weekly', desc: i18n.t('cron.run_once_a_week'), eqt: '0 0 * * 0' },
  { entry: '@daily (or @midnight)', desc: i18n.t('cron.run_once_a_day'), eqt: '0 0 * * *' },
  { entry: '@hourly', desc: i18n.t('cron.run_once_an_hour'), eqt: '0 * * * *' },
  { entry: '@minutely', desc: i18n.t('cron.run_every_minute'), eqt: '0 * * * *' },
];

const minDatasourcePeriod = _computed(() => {
  if (!isPlanLoaded.value) return DEFAULT_MIN_DATASOURCE_PERIOD_SECONDS;
  return plans.getIntegrationPlan.value?.minIntegrationPeriodSeconds
    ?? DEFAULT_MIN_DATASOURCE_PERIOD_SECONDS;
});

const minPeriod = _computed(() => (props.isDatasource ? minDatasourcePeriod.value : (props.minDefaultPeriod ?? 3600)));

const cronRules = _computed(() => [
  (value: string) => validateCron(value, minPeriod.value),
]);

const validCronItems = _computed(() => cronItems.filter((item) => item.duration >= minPeriod.value));

const hintLabel = _computed(() => props.hint || i18n.t('cron.input_hint'));
const attrsValue = _computed(() => vm?.proxy?.$attrs.value);
const isNull = _computed(() => attrsValue.value === null);
const canRemove = _computed(() => 'can-remove' in (vm?.proxy?.$attrs ?? {}));
const label = _computed(() => (isNull.value ? 'Remove existing' : 'Schedule'));
const labelClass = _computed(() => (isNull.value ? 'warning--text' : ''));
const appendIcon = _computed(() => (isNull.value || attrsValue.value?.length ? 'icon-dismiss' : ''));

const openDialog = () => {
  modalDialog.value?.openDialog();
};

const closeMenu = () => {
  if (inputCron.value?.isMenuActive) {
    setTimeout(() => inputCron.value?.blur?.(), 0);
  }
};

const clear = () => {
  emit('input', undefined);
  closeMenu();
};

const toggleNull = () => {
  if (!isNull.value) emit('input', null);
  else emit('input', []);
  closeMenu();
};

onMounted(async () => {
  try {
    await plans.refreshPlan(PlanTypes.INTEGRATION);
  } finally {
    isPlanLoaded.value = true;
  }
});

return { __sfc: true,DEFAULT_MIN_DATASOURCE_PERIOD_SECONDS, props, emit, vm, plans, isPlanLoaded, modalDialog, inputCron, cronItems, headers, items, minDatasourcePeriod, minPeriod, cronRules, validCronItems, hintLabel, attrsValue, isNull, canRemove, label, labelClass, appendIcon, openDialog, closeMenu, clear, toggleNull, _ref, _computed, getCurrentInstance, onMounted, ModalDialog, validateCron, usePlans, PlanTypes, i18n }
}

})